import axios from "axios";

export default {
  namespaced: true,
  state: {
    sent: false,
    show: false,
    email: "",
  },
  getters: {
    getSent: (state) => state.sent,
    getShow: (state) => state.show,
    getEmail: (state) => state.email,
  },
  mutations: {
    SET_SENT(state, payload) {
      state.sent = payload;
    },
    SET_SHOW(state, payload) {
      state.show = payload;
    },
    SET_EMAIL(state, payload) {
      state.email = payload;
    },
  },
  actions: {
    CREATE_COUPON({ state }) {
      const data = {
        email: state.email,
      };

      return new Promise((resolve, reject) => {
        axios
          .post(`/api/discount-coupon/create`, data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
